export function isZip(file) {
  return /\.zip$/i.test(file.name) || ["application/zip", "application/x-zip-compressed"].includes(file.type)
}

export async function chooseZipAction(file) {
  if (!isZip(file)) return "keep"

  const dialog = document.createElement("dialog")
  dialog.className = "workspace-panel max-w-lg w-full p-6"
  dialog.setAttribute("aria-label", "Import ZIP")
  dialog.innerHTML = `
    <form method="dialog" class="space-y-4">
      <h2 class="text-lg font-semibold text-warm-gray-900">Import ZIP</h2>
      <p data-zip-name class="break-words text-warm-gray-700"></p>
      <p class="workspace-warning-panel p-3">Files inside ZIPs are not watermarked when you import the ZIP unchanged.</p>
      <p class="text-sm text-warm-gray-700">Unzip to import files into a new folder. Only JPEG, PNG, and WebP images support watermarking, using your watermark settings. Other supported files stay unwatermarked.</p>
      <p class="text-sm text-warm-gray-500">Unzip limits: 25 MB ZIP, 100 MB expanded, 200 entries. Images, MP4, MOV, PDF, and TXT only. No encrypted ZIPs or nested archives.</p>
      <div class="flex flex-wrap gap-2">
        <button class="btn btn-primary" value="unzip" autofocus>Unzip and import</button>
        <button class="btn" value="keep">Import ZIP unchanged</button>
        <button class="btn btn-ghost" value="cancel">Cancel</button>
      </div>
    </form>
  `
  dialog.querySelector("[data-zip-name]").textContent = file.name
  document.body.appendChild(dialog)

  return new Promise(resolve => {
    dialog.addEventListener("close", () => {
      const action = dialog.returnValue
      dialog.remove()
      resolve(["keep", "unzip"].includes(action) ? action : null)
    }, { once: true })
    dialog.showModal()
  })
}

export function uploadResponse(xhr) {
  try {
    return JSON.parse(xhr.responseText)
  } catch {
    return { error: "Upload failed. Please try again." }
  }
}
